import { render, staticRenderFns } from "./LogBookForm.vue?vue&type=template&id=ff2a2824&"
import script from "./LogBookForm.vue?vue&type=script&lang=js&"
export * from "./LogBookForm.vue?vue&type=script&lang=js&"
import style0 from "./LogBookForm.vue?vue&type=style&index=0&id=ff2a2824&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports